import { useState } from 'react';

import CheckboxButton from '../../shared/CheckboxButton/CheckboxButton';
import MainButton from '../../shared/MainButton/MainButton';
import Typography, { FONT_TYPES } from '../../shared/Typography/Typography';

import styles from './MultiChoice.module.scss';

const MultiChoice = ({ stepName, texts, onNext }) => {
  const [checked, setChecked] = useState([]);
  const { title, subtitle, answers } = texts[stepName];

  const handleChange = (index) => (e) => {
    setChecked((prev) =>
      e.target.checked ? [...prev, index] : prev.filter((item) => item !== index),
    );
  };

  const handleNextClick = () => {
    if (!checked.length) return;

    onNext();
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.texts}>
        <Typography type={FONT_TYPES.h2} className={styles.title} isCenter>
          {title}
        </Typography>
        {subtitle && (
          <Typography type={FONT_TYPES.small_regular} className={styles.subtitle} isCenter>
            {subtitle}
          </Typography>
        )}
      </div>
      <div className={styles.answers}>
        {answers.map((text, index) => (
          <CheckboxButton
            key={`${stepName}_${index}`}
            id={`${stepName}_${index}`}
            name={stepName}
            value={index}
            checked={checked.includes(index)}
            onChange={handleChange(index)}
          >
            {text}
          </CheckboxButton>
        ))}
      </div>
      <MainButton
        className={styles.nextButton}
        isDisabledStyles={!checked.length}
        disabled={!checked.length}
        onClick={handleNextClick}
      >
        {texts.next}
      </MainButton>
    </div>
  );
};

export default MultiChoice;
